module.exports = __webpack_public_path__ + "static/media/PAKT4_DAWN.01e9282e.jpg";